module.exports = __webpack_public_path__ + "static/media/gal06013.0dd33c14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal06/gal06013.jpg
// module id = 488
// module chunks = 0